import { CloseOutlined } from "@mui/icons-material";
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";
import { blue } from "@mui/material/colors";
import React, { useState } from "react";
import { apiGatewayAxiosInstance } from "../../utils/axios";

function MaxBalanceLimitModel({ open, handleClose, currentData, getMasterBillingDetails, setOperationStatus }) {
    const [billingType, setBillingType] = useState(currentData.billingPaymentType || "Prepaid");
    const [currentBalance, setCurrentBalance] = useState(currentData.currentBalance || 0);
    const [capCheck, setCapCheck] = useState(currentData.capCheck || false);
    const [maxBalanceLimit, setMaxBalanceLimit] = useState(currentData.maxBalanceLimit || 0);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [description, setDescription] = useState("");

    const handleChange = e => {
        const { name, value } = e.target;

        if (value < 0 || value === "0") {
            setError(true);
            return;
        }
        setError(false);
        if (name === "maxBalanceLimit") {
            setMaxBalanceLimit(value);
        }

        if (name === "capCheck") {
            setCapCheck(e.target.checked);
        }
    };

    const handleBillingType = async ({ billingType, currentBalance, capCheck, maxBalanceLimit }) => {
        try {
            setLoading(true);
            const updatedBillingData = {
                ...currentData,
                billingPaymentType: billingType,
                currentBalance: currentBalance,
                capCheck: capCheck,
                maxBalanceLimit: maxBalanceLimit,
                description: description,
            };
            const response = await apiGatewayAxiosInstance.post("/billing_management/current-billing/change-billing-type", updatedBillingData);
            setOperationStatus({
                message: "BalanceLimit Updated Successfully.",
                success: true,
                failed: false,
            });
            getMasterBillingDetails();
            handleClose();
            setLoading(false);
            return response;
        } catch (error) {
            console.error("Error updating balance:", error);
            setLoading(false);
            throw error;
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="filter-dialog-title" maxWidth="xs" fullWidth>
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5">Max Balance Limit</Typography>
                <IconButton onClick={handleClose}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <FormControlLabel
                    control={<Checkbox checked={capCheck} onChange={handleChange} name="capCheck" size={"small"} />}
                    label="Cap Check"
                />

                {capCheck && (
                    <>
                        <Grid>
                            <TextField
                                fullWidth
                                style={{ width: "100%" }}
                                type="number"
                                inputProps={{
                                    step: "any",
                                }}
                                onWheel={e => e.target.blur()}
                                name="maxBalanceLimit"
                                value={maxBalanceLimit}
                                className="field-spacing"
                                label={
                                    <span>
                                        Balance Limit (INR) <span style={{ color: "red" }}>*</span>
                                    </span>
                                }
                                variant="outlined"
                                onChange={handleChange}
                                error={Boolean(errors.maxBalanceLimit) || error}
                                helperText={errors.maxBalanceLimit || (error && "Max Balance Limit cannot be negative or zero!")}
                            />
                            {maxBalanceLimit > 100000000 && (
                                <Typography variant="caption" color="error">
                                    Balance limit is 10 crore.
                                </Typography>
                            )}
                        </Grid>
                        <Grid>
                            <TextField
                                type="text"
                                name="description"
                                style={{ width: "100%" }}
                                className="field-spacing"
                                label="Description"
                                variant="outlined"
                                multiline
                                rows={3}
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                                inputProps={{
                                    maxLength: 500,
                                }}
                            />
                            <React.Fragment>
                                <Box
                                    sx={{
                                        p: 1,
                                        mx: 1,
                                        fontSize: "0.875rem",
                                        fontWeight: "700",
                                        display: "flex",
                                        flexDirection: "row-reverse",
                                    }}
                                >
                                    {`${description.length}`}
                                    /500
                                </Box>
                            </React.Fragment>
                        </Grid>
                    </>
                )}

                <Grid container flexDirection={"row-reverse"} gap={2} paddingTop={2}>
                    <Button onClick={handleClose} color="error">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleBillingType({ billingType, currentBalance, capCheck, maxBalanceLimit })}
                        disabled={error || !maxBalanceLimit || maxBalanceLimit > 100000000 || loading}
                        startIcon={loading ? <CircularProgress size={24} color="inherit" /> : null}
                    >
                        {loading ? "Submitting..." : "Submit"}
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default MaxBalanceLimitModel;
